<template>
    <form-row title="Which is Our Side?">
        <input-checkbox
            name="broker_our_sale"
            label="Our Listing"
            v-model="our_sale"
            class="sm:w-1/3"
            :read_only="read_only"
        />

        <input-checkbox
            name="broker_our_purchase"
            label="Our Purchase"
            v-model="our_purchase"
            class="sm:w-1/3"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        our_sale: {
            get() {
                return store.state.our_sale || 0;
            },
            set(val) {
                store.state.our_sale = (val ? 1 : 0);
            },
        },
        our_purchase: {
            get() {
                return store.state.our_purchase || 0;
            },
            set(val) {
                store.state.our_purchase = (val ? 1 : 0);
            },
        },
    },
}
</script>
